import { Button } from '@material-ui/core'
import React from 'react'

export const Submitting = ({ text = 'Loading...' }) => <Button disabled>{` ${text}`}</Button>

export default Submitting
